import { render, staticRenderFns } from "./DishStatistics.vue?vue&type=template&id=3a1d9809&"
import script from "./DishStatistics.vue?vue&type=script&lang=js&"
export * from "./DishStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports